module.exports = "/legacy/a1a49b298b99d7294787f3ecff6c23c2.png";